import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Grid,
  TextField,
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
  Select,
  Tooltip,
  ClickAwayListener,
} from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import MultipleSelect from '../../../components/MultipleSelect';
import TextCounter from '../../../components/TextCounter';
import ComboText from '../../ComboText/';
import { GRADESTUDY, LANGUAGES } from '../../../utils/ConstantsMain';
import moment from 'moment';
import { minHeight } from 'styled-system';

//import * as moment from 'moment';

const styles = () => ({
  select: {
    borderRadius: 2,
    border: '1px solid rgb(150,150,150)',
    '&:hover': {
      border: '1px solid rgba(0, 0, 0, 0.87)',
    },
  },
  selectRoot: {
    height: 74,
    overflow: 'auto',
    whiteSpace: 'normal',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  selectMenu: {
    padding: '10px 14px',
    fontSize: 16,
    lineHeight: 1,
  },
  sizeField: {
    width: '100%'
  },
  numberInput: {
    '@media screen and (max-width: 619.98px)': {
      width: '97%',
    }
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
  },
  heightSelect: {
    height: 76,
    '@media screen and (max-width: 619.98px)': {
      width: '88%',
    }
  },
  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    backgroundColor: '#fff',
    zIndex: 10,
  },
  listItemText: {
    fontSize: 14,
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  inputError: {
    border: '1px solid #d74242',
    '&:hover': {
      border: '1px solid #d74242',
    },
  },
  TextField: {
    maxWidth: '536px',
  },
  gridContainer: {
    marginTop: 35,
  },
  MultipleSelect: {
    maxWidth: '536px',
    width: '100%',
  },
  containerParagraph: {
    fontSize: 16,
    fontWeight: 'bold',
    width: 'min-content',
    padding: 16,
    backgroundColor: 'rgba(53, 185, 182, 0.1)',
    borderRadius: 4,
    margin: '0 0 16px',
  },
  textParagraph: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    margin: 0,
  },
  input_icon: {
    maxWidth: '544px',
    paddingRight: 8
  },
  input_iconLanguage: {
    width: '100%',
    display: 'flex',
  },
  autoComplete: {
    maxWidth: 544,
    minWidth: '76%',
    paddingRight: 8,
    '@media screen and (max-width: 399.98px)': {
      width: '90%',
    }
  },
  autoCompleteAreas: {
    width: '100%'
  },
  customTooltip: {
    backgroundColor: '#094565',
    margin: '4px 0 0',
    padding: 8,
    maxWidth: 232,
    lineHeight: 1.2,
  },
  tooltipParagraph: {
    margin: 0,
    fontSize: 14,
    '& b': {
      fontSize: 14,
      fontWeight: 'bold',
    },
  },

});

const AboutFormLawyer = props => {
  const [numChar, setNumChar] = useState(0);

  const [ringStyle, setRingStyle] = useState({
    stroke: '',
    strokeDasharray: '',
  });

  const styleRing = numChar => {
    const r = 15;
    const circleLength = 2 * Math.PI * r;
    const twitterBlue = 'rgb(29, 161, 242)';

    let colored = (circleLength * numChar) / 300;
    let gray = circleLength - colored > 0 ? circleLength - colored : 0;

    setRingStyle({
      stroke:
        300 - numChar <= 0
          ? 'red'
          : 300 - numChar <= 20
            ? 'orange'
            : twitterBlue,
      strokeDasharray: `${colored} ${gray}`,
    });
  };

  const countChar = event => {
    setNumChar(event.target.value.length);
    styleRing(event.target.value.length);
  };

  const {
    // dirty,
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    isValid,
    isLawyer,
    classes,
    setFieldValue,
    setError,
    createAt,
    role,
  } = props;
  const memberSince = moment.unix(createAt.seconds).utc().format('DD/MM/YYYY');
  const handleChangeMultiple = field => event => {
    event.preventDefault();
    let value = event.target.value;
    setFieldValue(field, value);
  };

  const handleChangeAuto = field => (event, value) => {
    event.preventDefault();
    let res = value.map((option, index) => option.title);
    setFieldValue(field, res);
  };
  const handleTagSelect = field => value => {
    setFieldValue(field, value);
  };

  // const getIndex = ESPECIALIDADITEMS.findIndex(
  //   item => item.title === values.specialties[0]
  // );

  const [openNumber, setOpenNumber] = useState(false);

  const handleTooltipCloseNumber = () => {
    setOpenNumber(false);
  };

  const handleTooltipOpenNumber = () => {
    setOpenNumber(true);
  };

  const [openCedula, setOpenCedula] = useState(false);

  const handleTooltipCloseCedula = () => {
    setOpenCedula(false);
  };

  const handleTooltipOpenCedula = () => {
    setOpenCedula(true);
  };

  const [openLanguages, setOpenLanguages] = useState(false);

  const handleTooltipCloseLanguages = () => {
    setOpenLanguages(false);
  };

  const handleTooltipOpenLanguages = () => {
    setOpenLanguages(true);
  };

  return (
    <form>
      <Grid
        container
        direction="column"
        classes={{ root: classes.gridContainer }}
      >
        <div className={classes.containerParagraph}>
          <p className={classes.textParagraph}>
            Miembro desde: {memberSince}
          </p>
        </div>
        <div className="contentInput">
          <TextField
            label="Nombre*"
            id="name"
            type="text"
            variant="outlined"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.name ? values.name : ''}
            helperText={touched.name && errors.name ? errors.name : ''}
            error={touched.name && errors.name ? true : false}
            fullWidth
            classes={{ root: classes.TextField }}
          />
          <div className="contentSpace" ></div>
        </div>
        <div className="contentInput">
          <TextField
            label="Apellido paterno*"
            id="firstLastName"
            type="text"
            variant="outlined"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.firstLastName ? values.firstLastName : ''}
            helperText={
              touched.firstLastName && errors.firstLastName
                ? errors.firstLastName
                : ''
            }
            error={touched.firstLastName && errors.firstLastName ? true : false}
            fullWidth
            classes={{ root: classes.TextField }}
          />
          <div className="contentSpace" ></div>
        </div>
        <div className="contentInput">
          <TextField
            label="Apellido materno*"
            id="secondLastName"
            type="text"
            variant="outlined"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.secondLastName ? values.secondLastName : ''}
            helperText={
              touched.secondLastName && errors.secondLastName
                ? errors.secondLastName
                : ''
            }
            error={touched.secondLastName && errors.secondLastName ? true : false}
            fullWidth
            classes={{ root: classes.TextField }}
          />
          <div className="contentSpace" ></div>
        </div>
        {/* <div className="contentInput">
          <ComboText
            labelText={'Áreas de práctica*'}
            sizeField={classes.sizeField}
            itemsCombo={ESPECIALIDADITEMS}
            widthField={536}
            multiple={true}
            handleChanges={handleTagSelect('specialties')}
            errors={errors.specialties}
            touched={touched.specialties}
            handleBlur={handleBlur}
            name={'specialties'}
            valuesMul={values.specialties}
          />
          <div className="contentSpace" ></div>
        </div> */}
        <Grid container direction="row">
          <Grid item xs classes={{ root: classes.input_icon }}>
            <TextField
              label="Número telefónico*"
              id="phone"
              type="text"
              variant="outlined"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.phone ? values.phone : ''}
              helperText={touched.phone && errors.phone ? errors.phone : ''}
              error={touched.phone && errors.phone ? true : false}
              fullWidth
              className={classes.numberInput}
              classes={{ root: classes.TextField }}
            />
          </Grid>
          <Grid>
            <div>
              {isMobile === true ?
                <ClickAwayListener onClickAway={handleTooltipCloseNumber}>
                  <Tooltip
                    onClose={handleTooltipCloseNumber}
                    open={openNumber}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    classes={{ tooltip: classes.customTooltip }}
                    title={
                      <p className={classes.tooltipParagraph}>
                        Este número de teléfono <b>no será publicado</b> en el sitio
                        y podría ocuparse para cuestiones de soporte técnico de la plataforma.
                      </p>
                    }
                    placement='left'
                  >
                    <img
                      style={{ marginTop: 12 }}
                      src="../../img/profile/ayuda.png"
                      alt="?"
                      onClick={handleTooltipOpenNumber}
                    />
                  </Tooltip>
                </ClickAwayListener> :
                <Tooltip
                  classes={{ tooltip: classes.customTooltip }}
                  title={
                    <p className={classes.tooltipParagraph}>
                      Este número de teléfono <b>no será publicado</b> en el sitio
                      y podría ocuparse para cuestiones de soporte técnico de la plataforma.
                    </p>
                  }
                  placement='bottom'
                >
                  <img style={{ marginTop: 12 }} src="../../img/profile/ayuda.png" alt="?" />
                </Tooltip>
              }
            </div>
          </Grid>
        </Grid>
        <FormControl
          style={{ maxWidth: '536px' }}
          classes={{ root: classes.heightSelect }}
          variant="outlined"
          error={touched.Items && errors.Items ? true : false}
        >
          <InputLabel
            htmlFor="select-multiple-checkbox"
            classes={{
              root: classes.inputLabelRoot,
              shrink: classes.inputLabelShrink,
            }}
          >
            {'Último grado de estudios'}
          </InputLabel>
          <Select
            id="gradeStudy"
            name="gradeStudy"
            value={values.gradeStudy ? values.gradeStudy : []}
            onChange={handleChange}
          >
            {GRADESTUDY &&
              GRADESTUDY.map((item, index) => (
                <MenuItem key={index} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
          </Select>
          {touched.Items && errors.Items ? (
            <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
              {errors.Items}
            </FormHelperText>
          ) : (
              ''
            )}
        </FormControl>


        <Grid container direction="row">
          <Grid item xs classes={{ root: classes.input_icon }}>
            <TextField
              label="Cédula profesional"
              id="cedula"
              type="text"
              variant="outlined"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.cedula ? values.cedula : ''}
              helperText={touched.cedula && errors.cedula ? errors.cedula : ''}
              error={touched.cedula && errors.cedula ? true : false}
              fullWidth
              classes={{ root: classes.TextField }}
              className={classes.numberInput}
            />
          </Grid>
          <Grid>
            <div>
              {isMobile === true ?
                <ClickAwayListener onClickAway={handleTooltipCloseCedula}>
                  <Tooltip
                    onClose={handleTooltipCloseCedula}
                    open={openCedula}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    classes={{ tooltip: classes.customTooltip }}
                    title={
                      <p className={classes.tooltipParagraph}>
                        El campo "cédula profesional" <b>no es obligatorio</b>, pero recomendamos
                        llenar el campo con fines de <b>credibilidad</b> y <b>veracidad</b> de la información proporcionada.
                      </p>
                    }
                    placement='left'
                  >
                    <img
                      style={{ marginTop: 12 }}
                      src="../../img/profile/ayuda.png"
                      alt="?"
                      onClick={handleTooltipOpenCedula}
                    />
                  </Tooltip>
                </ClickAwayListener> :
                <Tooltip
                  classes={{ tooltip: classes.customTooltip }}
                  title={
                    <p className={classes.tooltipParagraph}>
                      El campo "cédula profesional" <b>no es obligatorio</b>, pero recomendamos
                      llenar el campo con fines de <b>credibilidad</b> y <b>veracidad</b> de la información proporcionada.
                    </p>
                  }
                  placement='bottom'
                >
                  <img style={{ marginTop: 12 }} src="../../img/profile/ayuda.png" alt="?" />
                </Tooltip>
              }
            </div>
          </Grid>
        </Grid>
        <div className="contentInput">
          <TextField
            label="Años de experiencia"
            id="expYears"
            type="text"
            variant="outlined"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.expYears ? values.expYears : ''}
            helperText={
              touched.expYears && errors.expYears ? errors.expYears : ''
            }
            error={touched.expYears && errors.expYears ? true : false}
            fullWidth
            classes={{ root: classes.TextField }}
          />
          <div className="contentSpace" ></div>
        </div>

        <div className="contentInput">
          <TextField
            label="Número de colegiado"
            id="colegNumber"
            type="text"
            variant="outlined"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.colegNumber ? values.colegNumber : ''}
            helperText={
              touched.colegNumber && errors.colegNumber ? errors.colegNumber : ''
            }
            error={touched.colegNumber && errors.colegNumber ? true : false}
            fullWidth
            classes={{ root: classes.TextField }}
          />
          <div className="contentSpace" ></div>
        </div>
        {/* <div className={classes.languageContainer}> */}
        <Grid container className={classes.containerLanguage}>
          <Grid item classes={{ root: classes.input_iconLanguage }}>
            <ComboText
              labelText={'Idioma'}
              itemsCombo={LANGUAGES}
              sizeField={classes.autoComplete}
              multiple={true}
              handleChanges={handleTagSelect('languages')}
              errors={errors.languages}
              touched={touched.languages}
              handleBlur={handleBlur}
              name={'languages'}
              valuesMul={values.languages}
            />
            <Grid item>
              <div>
                {isMobile === true ?
                  <ClickAwayListener onClickAway={handleTooltipCloseLanguages}>
                    <Tooltip
                      onClose={handleTooltipCloseLanguages}
                      open={openLanguages}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      classes={{ tooltip: classes.customTooltip }}
                      title={
                        <p className={classes.tooltipParagraph}>
                          Este campo se refiere a los idiomas que dominas.
                          </p>
                      }
                      placement='left'
                    >
                      <img
                        style={{ marginTop: 12, minWidth: 25 }}
                        src="../../img/profile/ayuda.png"
                        alt="?"
                        onClick={handleTooltipOpenLanguages}
                      />
                    </Tooltip>
                  </ClickAwayListener> :
                  <Tooltip
                    classes={{ tooltip: classes.customTooltip }}
                    title={
                      <p className={classes.tooltipParagraph}>
                        Este campo se refiere a los idiomas que dominas.
                        </p>
                    }
                    placement='bottom'
                  >
                    <img style={{ marginTop: 12, minWidth: 25 }} src="../../img/profile/ayuda.png" alt="?" />
                  </Tooltip>
                }
              </div>
            </Grid>
          </Grid>
        </Grid>
        {/* </div> */}
      </Grid>

      <div className="horizontal-layout" style={{ marginTop: 15 }}>
        <ButtonBase
          type="submit"
          onClick={handleSubmit}
          variant="primary"
          disabled={!isValid}
          classes={{ root: classes.ButtonBase }}
        >
          Guardar cambios
        </ButtonBase>
      </div>
    </form>
  );
};

export default withStyles(styles)(AboutFormLawyer);
